<script>
    export let width = 48;
    export let height = 48;
    export let color = "#fff";
</script>

<svg {width} {height} viewBox="0 0 512 512">
    <rect
        fill="none"
        x="48"
        y="96"
        width="416"
        height="320"
        rx="40"
        ry="40"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
    <path
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M112 160l144 112 144-112"
    />
</svg>
